import r2wc from "@r2wc/react-to-web-component";
import { CheckoutContainer } from "../components/CheckoutContainer";

const CheckoutWebComponent = r2wc(CheckoutContainer, {
  props: {
    vehicleId: "string",
    vehicleName: "string",
    totalPrice: "number",
    from: "string",
    to: "string",
    adults: "number",
    children: "number",
    infants: "number",
    pets: "number",
    apiKey: "string",
    fleetId: "string",
    apiBaseUrl: "string",
    stripePublishableKey: "string",
    theme: "string",
    defaultLogoUrl: "string",
    openInNewTab: "boolean",
    appBaseUrl: "string",
    onSuccess: "function",
    onError: "function",
    onNavigateToSuccess: "function",
    onNavigateToError: "function",
  },
  events: {
    onSuccess: { bubbles: true, composed: true },
    onError: { bubbles: true, composed: true },
    onNavigateToSuccess: { bubbles: true, composed: true },
    onNavigateToError: { bubbles: true, composed: true },
  },
});

if (!customElements.get("fm-checkout")) {
  customElements.define("fm-checkout", CheckoutWebComponent);
}
